import React from 'react';
export default function SyncAlt(_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "1em", height: "1em", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960" },
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M271-120 80-311l192-192 42 42-120 120h646v60H194l119 119zm418-337-42-42 119-119H120v-60h646L646-798l42-42 192 192z" })));
}
